import React from "react";

function Applynow() {
  return (
    <>
      <div className="applynow mt-20 mb-10 content-center">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform?embedded=true"
          width="640"
          height="600 vw"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          title="Your Unique Title Goes Here"
          className="formData"
        >
          Loading…
        </iframe>
      </div>
    </>
  );
}

export default Applynow;
